import { render, staticRenderFns } from "./ProductTagsNew.vue?vue&type=template&id=0d96ffd2&scoped=true&"
import script from "./ProductTagsNew.vue?vue&type=script&lang=js&"
export * from "./ProductTagsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d96ffd2",
  null
  
)

export default component.exports